import GenericTabComponent from "../../components/GenericTabComponent";
import About from "./Tabs/About";
import LogoMascot from "./Tabs/LogoMascot";

export default function AsiaRugbyA207s() {
  const content = [
    { label: "About", component: <About /> },
    { label: "Logo and Mascot", component: <LogoMascot /> },
  ];
  const pagetitle = "Asia Rugby Under-20 7s Championship 2025",
    desktopBanner = "/img/AsiaRugbyU207s/desktopBanner.jpg",
    // desktopBanner = "https://biharsports.org/img/model-code-conduct/AsiaRugbyU207s/desktopBanner.jpg",
    mobileBanner = "/img/AsiaRugbyU207s/mobileBanner.jpg";
    // mobileBanner = "https://biharsports.org/img/model-code-conduct/AsiaRugbyU207s/mobileBanner.jpg";
  return (
    <>
      <GenericTabComponent
        content={content}
        desktopBanner={desktopBanner}
        mobileBanner={mobileBanner}
        pageTitle={pagetitle}
      />
    </>
  );
}
